import PageNotFound from "../../pages/PageNotFound";

const SecureRoute = ({ route }) => {
  const userRole = JSON.parse(localStorage.getItem("user"));
  const isAuthorized = route?.roles?.includes(userRole?.role_id);
  return isAuthorized ? route?.component : <PageNotFound />;
};
export default SecureRoute;
